import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import TermsCom from '../TermsCom';

const TermsAndConditionsModal = ({
  showTncModal,
  setShowTncModal,
  handleTncScroll,
  isTncRead,
  handleAcceptTerms
}) => {
  return (
    <Modal 
      show={showTncModal} 
      onHide={() => setShowTncModal(false)} 
      size="lg" 
      centered 
      backdrop="static"
      data-bs-theme="dark"
    >
      <Modal.Header closeButton className="bg-dark text-white border-secondary">
        <Modal.Title>Terms and Conditions</Modal.Title>
      </Modal.Header>

      <Modal.Body 
        className="bg-dark p-3 text-white" 
        style={{ height: '60vh', overflowY: 'auto' }}
        onScroll={handleTncScroll}
      >
        <TermsCom />
      </Modal.Body>

      <Modal.Footer className="bg-dark border-secondary">
        {!isTncRead && <span className="text-warning small me-auto">Please scroll to the bottom to accept.</span>}
        
        <Button variant="outline-light" onClick={() => setShowTncModal(false)}>
          Close
        </Button>

        {Boolean(isTncRead) && (
          <Button variant="primary" onClick={handleAcceptTerms} disabled={!isTncRead}>
            I Accept
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default TermsAndConditionsModal;
